//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEExtendedObject.js";
let d=[[],[[[],"GetEngObject",{R_:{engObject:"AME.IEngObject"}},0,0],[[],"GetParent",{R_:{parentNode:"AME.INodeObject"}},0,0],[[],"GetName",{R_:{name:''}},0,0],[["numChildren"],"GetChildren",{R_:{children:"AME.INodeObject[]"}},0,0],[["numChildren"],"GetChildrenByNavigatorOrder",{R_:{children:"AME.INodeObject[]"}},0,0]],[]];
SPLM.AME.AMEBaseNode = class extends SPLM.AME.AMEExtendedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.AMEBaseNode";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.AMEBaseNode.NodeType = Object.freeze({
    "Project" : "Project", "Aspect" : "Aspect"});

export default SPLM;